import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ShieldCheck, Leaf, Hammer, Clock } from "lucide-react";
import { cn } from "@/lib/utils";
export default function TheGreenStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    badge: "Verified Protection",
    title: "Licensed & Insured",
    description: "Rest easy knowing your property is in safe hands. We maintain full licensing and comprehensive insurance coverage for every project we undertake.",
    icon: ShieldCheck
  }, {
    badge: "Sustainable Choice",
    title: "Eco-Friendly Materials",
    description: "We prioritize the environment by using sustainable materials and green practices whenever possible, ensuring a healthier home and planet.",
    icon: Leaf
  }, {
    badge: "Premium Quality",
    title: "High-Quality Craftsmanship",
    description: "Our team brings over 15 years of experience to every job, delivering meticulous attention to detail and superior finishes that stand the test of time.",
    icon: Hammer
  }, {
    badge: "Client Promise",
    title: "Reliable & Timely",
    description: "We respect your time and schedule. Count on us for punctual arrivals, efficient work, and clear communication from start to finish.",
    icon: Clock
  }];
  return <section id="the-green-standard" className="dark bg-card text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/green_haven_logo_mark.png" alt="" className="w-[120%] md:w-[60%] max-w-3xl opacity-[0.03] grayscale blur-sm transform -rotate-12" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            The Green Standard
          </h2>
          <p className="text-muted-foreground text-lg">
            Setting the benchmark for quality, reliability, and sustainability in property maintenance.
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16 max-w-5xl mx-auto transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col items-start gap-4 group">
              <div className="flex items-center gap-3 mb-1">
                <Badge variant="default" className="bg-primary/10 text-primary hover:bg-primary/20 border-primary/20 px-3 py-1 text-xs uppercase tracking-wider font-semibold">
                  {feature.badge}
                </Badge>
                <div className="h-px flex-1 bg-border/50 group-hover:bg-primary/30 transition-colors duration-300" />
              </div>
              
              <div className="flex flex-col gap-3">
                <h3 className="text-2xl font-bold text-foreground flex items-center gap-3">
                  <feature.icon className="size-6 text-primary" />
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed text-base">
                  {feature.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}